import React from "react";
import styled from "styled-components";

const FloatingButton = styled.div`
  position: fixed;
    bottom: 8px;
    right: 8px;
    width: 24px;
    height: 24px;
  background-color:${({ color }) => color || '#0056d2'};;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  cursor: pointer;
    font-size: 14px;
  z-index: 1000;
`;

const ScrollButton = ({
    color = ""
}) => {
    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;

        if (scrollPosition + windowHeight >= documentHeight - 1) {
            // 滾動到底部，回到頂部
            window.scrollTo({ top: 0, behavior: "smooth" });
        } else if (scrollPosition === 0) {
            // 滾動到頂部，跳到底部
            window.scrollTo({ top: documentHeight, behavior: "smooth" });
        } else {
            // 默認行為，回到頂部
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    return (
        <FloatingButton color={color} onClick={handleScroll} title="回到頂部或底部">
            ↑↓
        </FloatingButton>
    );
};

export default ScrollButton;
